import { formatNumber, formatPercent } from '@angular/common';
import { CmpsInsightCoachingPerformanceData, ToolTipData } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../store';
import { ColourGroup } from '../models/colour-group.model';
import { MetricItem } from '../models/metric-item.model';
import { TranslationKeyMap } from '../my-performance-card.i18n';

import { extractMetrics } from './extract-metrics.function';

export function getProgressDataForPillar(
    colourGroups: ColourGroup[],
): CmpsInsightCoachingPerformanceData[] {
    if (epicDependencies == null || epicDependencies.injector == null) {
        return [];
    }
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const metrics = extractMetrics(colourGroups);

    const createTooltipData = (metric: MetricItem): ToolTipData => ({
        title:
            metric.metricName != null
                ? metric.metricName
                : translateService.instant(TranslationKeyMap._9944_BLANK),
        number: formatNumber(metric.actual ?? 0, 'en-CA', '1.0-2'),
    });

    const createProgressBarData = (
        group: ColourGroup,
        metricsCount: number,
    ): CmpsInsightCoachingPerformanceData => {
        const tooltipData = group.metrics?.map(createTooltipData) ?? [];
        const color =
            group.metrics?.some((m) => m.target == null) ?? false
                ? '#abacaf'
                : group.colour;
        const metricsLength =
            group.metrics != null && group.metrics.length > 0
                ? group.metrics.length
                : 0;

        return {
            labelValue:
                metricsLength > 0
                    ? formatPercent(
                          metricsLength / metricsCount,
                          'en-CA',
                          '1.0',
                      )
                    : undefined,
            percent:
                metricsLength > 0
                    ? formatPercent(
                          metricsLength / metricsCount,
                          'en-CA',
                          '1.4',
                      )
                    : undefined,
            backgroundColor: color,
            tooltipData,
        };
    };

    return (
        colourGroups?.map((group) =>
            createProgressBarData(group, metrics.length),
        ) ?? []
    );
}
